import { CompanyAuditLogActionName } from './enums'
import type { InvestigationAuditLogPayload } from './schemas/investigationAuditLogSchema'

/**
 * Audit log entries of what FaceUp did itself rather than a member. They are written without an
 * actor and shown with FaceUp as one. Any other entry without an actor is a reporter's or a deleted
 * member's, so an action belongs here only if no person ever performs it.
 */
const systemCompanyAuditLogActions = [
  CompanyAuditLogActionName.InvestigationMigratedFromLegacyBySystem,
] as const satisfies readonly CompanyAuditLogActionName[]

const systemInvestigationAuditLogTypes = [
  'InvestigationMigratedFromLegacyBySystem',
] as const satisfies readonly InvestigationAuditLogPayload['type'][]

export type SystemCompanyAuditLogAction = (typeof systemCompanyAuditLogActions)[number]

export type SystemInvestigationAuditLogType = (typeof systemInvestigationAuditLogTypes)[number]

export const isSystemInvestigationAuditLogType = (
  type: InvestigationAuditLogPayload['type']
): type is SystemInvestigationAuditLogType =>
  (systemInvestigationAuditLogTypes as readonly string[]).includes(type)
